import { render, staticRenderFns } from "./TicketProfile.vue?vue&type=template&id=2aa5c15a&"
import script from "./TicketProfile.vue?vue&type=script&lang=js&"
export * from "./TicketProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports